<template>
  <div class="roll-call">
    <div class="screen">
      <div class="warehouse" @click="openPicker(1)">
        <span v-if="warehouse.id">{{warehouse.text}}</span>
        <span v-else>选择仓库</span>
        <van-icon class="icon" name="arrow-down" color="#333333" />
      </div>
      <div class="commuting" @click="openPicker(2)">
        <span v-if="rollCall.id">{{rollCall.text}}</span>
        <span v-else>选择班次</span>
        <van-icon class="icon" name="arrow-down" color="#333333" />
      </div>
    </div>
    <div class="temporary-container">
      <div class="title">
        <p class="title-name">姓名</p>
        <p class="title-company">劳务公司</p>
        <p class="title-operation">操作</p>
      </div>
      <ul class="temporary-list" v-if="warehouse.id&&rollCall.id&&temporaryList.length>0">
        <li class="temporary-item" v-for="(value,index) in temporaryList" :key="index">
          <p class="name">{{value.name}}</p>
          <p class="company">{{value.company}}</p>
          <van-button v-if="value.status" class="btn disable" disabled>点名</van-button>
          <van-button v-else class="btn" @click="openPickerDept(value.id)">点名</van-button>
        </li>
      </ul>
      <div class="nothing" v-else-if="warehouse.id&&rollCall.id&&temporaryList.length===0">暂无内容</div>
      <div class="nothing" v-else>暂无内容，请先选择仓库及班次</div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :title="pickerTitle"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="showDeptPicker" round position="bottom">
      <van-picker
        show-toolbar
        title="分配所属部门"
        :columns="deptColumns"
        @cancel="showDeptPicker = false"
        @confirm="onDeptConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import Model from "models/model";
const model = new Model();
import Vue from "vue";
import { Icon, Button, Picker, Popup, Toast, Dialog } from "vant";

Vue.use(Icon)
  .use(Button)
  .use(Picker)
  .use(Popup)
  .use(Toast)
  .use(Dialog);
export default {
  data() {
    return {
      warehouse: {
        id: "",
        text: ""
      },
      rollCall: {
        id: "",
        text: ""
      },
      warehouseList: [], //仓库
      rollCallType: [
        {
          id: 1,
          text: "上班"
        },
        {
          id: 2,
          text: "下班"
        }
      ],
      showPicker: false,
      pickerTitle: "",
      pickerType: "",
      columns: [],
      //临时工列表
      tempId: "",
      temporaryList: [],
      showDeptPicker: false, //部门选择
      deptColumns: []
    };
  },
  created() {
    window.document.title = "临时工点名";
    this.getWarehouseList();
  },
  methods: {
    //获取仓库数据
    getWarehouseList() {
      model.warehouseList().then(res => {
        if (res.success) {
          let warehouseList = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.text = value.name;
            warehouseList.push(obj);
          });
          this.warehouseList = warehouseList;
        }
      });
    },
    //显示头部选择器
    openPicker(type) {
      this.pickerType = type;
      if (type === 1) {
        this.pickerTitle = "仓库";
        this.columns = this.warehouseList;
        this.showPicker = true;
      } else if (type === 2) {
        this.pickerTitle = "班次";
        this.columns = this.rollCallType;
        this.showPicker = true;
      }
    },
    //头部选择器确认
    onConfirm(value) {
      if (this.pickerType === 1) {
        this.warehouse = value;
      } else if (this.pickerType === 2) {
        this.rollCall = value;
      }
      this.showPicker = false;
      this.getTemporaryList();
    },
    //获取临时工列表数据
    getTemporaryList() {
      if (this.warehouse.id && this.rollCall.id) {
        let warehouseId = this.warehouse.id;
        let type = this.rollCall.id;
        const toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中..."
        });
        model.tempList(warehouseId, type).then(res => {
          console.log(res);
          if (res.success) {
            let temporaryList = [];
            res.result.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.name = value.name;
              obj.company = value.laborName;
              obj.status = value.check === 1;
              temporaryList.push(obj);
            });
            this.temporaryList = temporaryList;
            Toast.clear();
            this.getDeptList(warehouseId);
          } else {
            Toast.clear();
            Toast(res.message);
          }
        });
      }
    },
    //获取部门数据
    getDeptList(warehouseId) {
      model.deptList(warehouseId).then(res => {
        console.log(res);
        if (res.success) {
          let deptColumns = [];
          res.result.map(value => {
            if (res.success) {
              let object = {};
              object.id = value.id;
              object.text = value.name;
              // object.children = [];
              // if (value.productLineList.length > 0) {
              //   value.productLineList.map(v => {
              //     let obj = {};
              //     obj.id = v.id;
              //     obj.text = v.name;
              //     object.children.push(obj);
              //   });
              // } else {
              //   let obj = {
              //     id: "",
              //     text: ""
              //   };
              //   object.children.push(obj);
              // }
              deptColumns.push(object);
            }
          });
          this.deptColumns = deptColumns;
        }
      });
    },
    openPickerDept(id) {
      if (this.rollCall.id === 1) {
        this.tempId = id;
        this.showDeptPicker = true;
      } else {
        Dialog.confirm({
          title: "下班点名",
          message: "是否确定该员工下班"
        })
          .then(() => {
            let type = 2;
            let data = {
              id,
              type
            };
            model.signCheck(data).then(res => {
              if (res.success) {
                this.temporaryList.map((value, index) => {
                  if (value.id === id) {
                    this.temporaryList[index].status = true;
                  }
                });
              } else {
                Toast(res.message);
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    onDeptConfirm(value, index) {
      let id = this.tempId;
      let type = this.rollCall.id;
      let deptId = value.id;
      // let projectLineId = 0;
      // if (value[1]) {
      //   projectLineId = this.deptColumns[index[0]].children[index[1]].id;
      // }
      let data = {
        id,
        type,
        deptId
      };
      model.signCheck(data).then(res => {
        if (res.success) {
          this.showDeptPicker = false;
          this.temporaryList.map((value, index) => {
            if (value.id === id) {
              this.temporaryList[index].status = true;
            }
          });
        } else {
          Toast(res.message);
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
.roll-call {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-sizing: border-box;
  .screen {
    height: 44px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    font-size: 15px;
    align-items: center;
    border-radius: 4px;
    margin-bottom: 12px;
    .warehouse {
      flex: 1;
      display: flex;
      height: 44px;
      align-items: center;
      justify-content: center;
    }
    .commuting {
      flex: 1;
      display: flex;
      height: 44px;
      align-items: center;
      justify-content: center;
    }
    .icon {
      margin-left: 5px;
    }
  }
  .temporary-container {
    flex: 1;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 0 12px 30px 12px;
    overflow: auto;
    .title {
      height: 44px;
      display: flex;
      font-size: 15px;
      font-weight: bold;
      align-items: center;
    }
    .title-name {
      width: 88px;
      padding-left: 8px;
      box-sizing: border-box;
    }
    .title-company {
      width: 151px;
      padding-left: 12px;
      box-sizing: border-box;
    }
    .temporary-list {
      .temporary-item {
        height: 36px;
        display: flex;
        align-items: center;
        font-size: 15px;
        border-top: 1px solid #eeeeee;
        .name {
          width: 88px;
          padding-left: 8px;
          box-sizing: border-box;
        }
        .company {
          width: 151px;
          padding-left: 12px;
          box-sizing: border-box;
        }
        .btn {
          width: 44px;
          height: 22px;
          line-height: 22px;
          background: rgba(0, 104, 255, 1);
          border-radius: 2px;
          padding: 0;
          font-size: 12px;
          color: rgba(255, 255, 255, 1);
          border: 0;
        }
        .disable {
          background: #e5e5e5;
        }
      }
    }
    .nothing {
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
      text-align: center;
      padding-top: 120px;
    }
  }
}
</style>